// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sopStep-card-title {\n  margin-left: -5px;\n  font-size: 0.8rem;\n}\n.card-sop-step-list {\n  padding: 0px 16px !important;\n  min-height: 28px;\n}\n.sop-step-table-info-banner {\n  position: relative;\n  top: 150px;\n  left: 50%;\n  -webkit-transform: translate(-50%);\n          transform: translate(-50%);\n  width: 700px;\n  z-index: 1000;\n}", ""]);
// Exports
module.exports = exports;
